/* * @Author: Wei Guojun * @Date: 2021-04-14 09:55:13 * @Last Modified by: Wei
Guojun * @Last Modified time: 2022-02-10 14:43:44 */
<template>
  <div class="import_index">
    <section>
      <div class="title">
        共有
        <span style="color: red">{{ this.table_total || 0 }}</span>
        个正常信息订单
      </div>
      <div class="table">
        <el-table
          border
          :index="indexMethod"
          :height="tableHeight"
          :data="tableData"
          style="width: 100%"
          size="mini"
          :row-class-name="status_change"
          id="tableBox"
        >
          <el-table-column align="center" width="50" label="选择">
            <template slot-scope="scope">
              <el-checkbox
                :value="parcel_id_list.includes(scope.row.id)"
                @change="checkBox(scope.row.id)"
              ></el-checkbox>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="序号"
            width="50"
            type="index"
          ></el-table-column>
          <el-table-column width="100" align="center" label="收件人姓名">
            <template slot-scope="scope">
              <div>{{ scope.row.receiver_name }}</div>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="收件人联系方式">
            <template slot-scope="scope">
              <div>{{ scope.row.receiver_phone }}</div>
            </template>
          </el-table-column>
          <el-table-column label="收件人地址">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.receiver_province +
                  " " +
                  scope.row.receiver_city +
                  " " +
                  scope.row.receiver_district +
                  " " +
                  scope.row.receiver_address
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="寄件人姓名">
            <template slot-scope="scope">
              <div>{{ scope.row.sender_name }}</div>
            </template>
          </el-table-column>
          <el-table-column width="120" align="center" label="寄件人联系方式">
            <template slot-scope="scope">
              <div>{{ scope.row.sender_phone }}</div>
            </template>
          </el-table-column>
          <el-table-column label="寄件人地址">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.sender_province +
                  " " +
                  scope.row.sender_city +
                  " " +
                  scope.row.sender_district +
                  " " +
                  scope.row.sender_address
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" align="center" label="物品类型">
            <template slot-scope="scope">
              <div>{{ scope.row.item_type }}</div>
            </template>
          </el-table-column>
          <el-table-column width="80" align="center" label="快递类型">
            <template slot-scope="scope">
              <div>{{ scope.row.express_type | kdtype }}</div>
            </template>
          </el-table-column>
          <el-table-column width="80" align="center" label="重量">
            <template slot-scope="scope">
              <div>{{ scope.row.goods_weight }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="备注">
            <template slot-scope="scope">
              <div>{{ scope.row.item_note }}</div>
            </template>
          </el-table-column>
          <el-table-column align="center" width="120" label="操作">
            <template slot-scope="scope">
              <div class="operation">
                <a @click="showDel(scope.row.id)" href="javascript:void(0)"
                  >删除</a
                >
                <a @click="edit(scope.row)" href="javascript:void(0)">编辑</a>
              </div>
            </template>
          </el-table-column>
          <div slot="empty" class="noBody">
            <img src="@/assets/images/nodata.png" alt />
          </div>
        </el-table>
      </div>
      <div class="pages">
        <div class="pages_left">

          <el-checkbox v-model="value_add_type" @change="topayChange" v-show="$store.state.bindKdy!=10">到付</el-checkbox>
        </div>
        <div class="pages_right">
          <el-pagination
            :page-size="page_size"
            :current-page.sync="currPage"
            @size-change="changeSizes"
            :page-sizes="[30, 50, 100, 200, 500]"
            @current-change="currentPage"
            layout="sizes,prev, pager, next, jumper"
            :total="table_total"
          ></el-pagination>
          <div slot="append" class="sure" type="primary">确定</div>
        </div>
      </div>
    </section>
    <footer>
      <div class="footer">
        <div>
          <div class="allCheck">
            <el-checkbox @change="allCheck" v-model="all">本页全选</el-checkbox>
            <span
              >已选<b>{{ parcel_id_list.length }}</b></span
            >
          </div>
          <div class="btn">
            <el-button type="primary" class="footBtn" @click.prevent="submitKdy" v-if="$store.state.bindKdy != 10"
              >批量提交给快递员</el-button
            > 
            <el-button class="footBtn" :type="value_add_type ? 'info' : 'primary'" :disabled="value_add_type"  @click.prevent="allPrint" :loading="allPrintLoading"
              >直接打印</el-button
            >
            <el-button class="footBtn" :type="value_add_type ? 'info' : 'primary'"  :disabled="value_add_type" @click="saveTowait()"
              >导入保存稍后打印</el-button
            >
            <el-button class="footBtn" type="primary" @click="batchDel()"
              >批量删除</el-button
            >
          </div>
        </div>
      </div>
    </footer>
    <el-dialog
      width="534px"
      height="208px"
      :visible.sync="tips"
      top="375px"
      center
    >
      <div class="content">
        还有
        <span>{{ count.abnormal_count }}个</span>异常信息订单，请修改后再导入
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="tips = false">我知道了</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="534px"
      height="208px"
      top="375px"
      :visible.sync="isDel"
      center
    >
      <div class="content">
        确定
        <span>删除</span>已选订单信息？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDel = false">取 消</el-button>
        <el-button type="primary" @click="del">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-if="dialog"
      center
      top="50px"
      width="1300px"
      title="订单信息预览"
      :visible.sync="dialog"
      @close="closeDialog"
    >
      <div style="height: 550px">
        <editSheet ref="editSheet" :itemData="itemData"></editSheet>
      </div>
    </el-dialog>
    <component :is="curComponent[0]" :ref="curComponent[1]"></component>
  </div>
</template>

<script>
import editSheet from "@/components/editSheet";
import home from "@/api/home.js";
import print from "@/api/print.js";
import bindKdy from "@/api/bindKdy.js";
import util from "@/util/util";
import { mapGetters } from "vuex";
import request from "@/util/request";
import { PrintWaiting, startPrinting } from '@/util/ptintTool.js';
export default {
  name: "normalSheet",
  data() {
    return {
      tableHeight: 300,
      count: {
        abnormal_count: 0,
        normal_count: 0,
      },
      tableData: [],
      page_size: 30,
      currPage: 1, //当前页数
      table_total: 0, //总数
      showPage: true,
      isDel: false,
      isPrint: false,
      isLoading: false,
      _qrcode: null,
      tips: false,
      isNull: false,
      isUp: false,
      isAuth: false,
      parcel_id_list: [],
      all: false,
      itemData: {},
      dialog: false,
      ysBill:false,
      value_add_type:false,
      rowBgcolor:[],
      curComponent:[],
      allPrintLoading: false,
      waitprint_orderid:[],
      submit_orderid:[]
    };
  },
  computed: {
    ...mapGetters(["getFrom"]),
  },
  filters:{
    kdtype(data){
      var string = "";
      if (data == 'TK') {
        string = "智橙网";
      } else if (data == 'PK') {
        string = "普通快递";
      } else {
        string = "";
      }
      return string;
    },
  },
  components: {
    //组件声明
    editSheet,
  },
 
  created() {
    //创建时执行
  },
  mounted() {
    //数据挂载
    this.loadData();
    util.getTableHeight(this, document.getElementById("tableBox"), 104);
    window.addEventListener("resize", () => {
      util.getTableHeight(this, document.getElementById("tableBox"), 104);
    });
  },
  destroyed() {
    window.removeEventListener("resize", () => {
      util.getTableHeight(this, document.getElementById("tableBox"), 104);
    });
  },
  methods: {
    topayChange(value){
      if(value){
        this.$message.warning('到付单仅支持提交快递员打印!')
      }
    },
    //函数声明
    closeDialog() {},
    /** 加载数据 */
    loadData() {
      let userset = JSON.parse(this.$store.state.userSet);
      this.page_size = userset.sizeNum || 30;
      home
        .getTempOrder(this, {
          right_page: this.currPage,
          right_size: this.page_size,
        })
        .then((res) => {
          if (res.success) {
            this.tableData = res.data.right_list;
            this.count.abnormal_count = res.data.wrong_num;
            this.count.normal_count = res.data.right_num;
            this.table_total = res.data.right_num;
            this.$store.state.rightNum = this.table_total;
            this.rowBgcolor = this.$store.state.mgcColorRow;
          }
        });
    },
    /** 单选单个Box */
    checkBox(e) {
      let list = this.parcel_id_list;
      if (list.indexOf(e) != -1) {
        list.splice(
          list.findIndex((item) => item === e),
          1
        );
      } else {
        list.push(e);
      }
      if (list.length > 0 && list.length < this.tableData.length) {
        this.isAll = true;
        this.all = false;
      } else if (list.length == this.tableData.length) {
        this.isAll = false;
        this.all = true;
      } else {
        this.isAll = false;
        this.all = false;
      }
      this.parcel_id_list = list;
    },
    /** 全选 */
    allCheck(e) {
      let list = [];
      if (e) {
        this.tableData.forEach((item) => {
          list = [...list, item.id];
        });
        this.all = true;
      } else {
        this.all = false;
      }
      this.parcel_id_list = list;
    },
    //动态行颜色
    status_change({row,rowIndex}){
      if(this.rowBgcolor.includes(row.id)){
        return 'ysb_wornig_row'
      }else{
        return ''
      }
    },
    showRealnameBox(){
      let c = () => import(`@/components/realName`);
      this.curComponent = [c, "realNameRef"];
    },
    //敏感词送检
    async jgSensitivewords(type){
      const checkYwyreal = await bindKdy.checkRealName(this);
      if(checkYwyreal.code == '7022'){
        this.$alert('检测到当前账号为业务员身份证号实名,为了正常使用请更新该账号实名', '提示', {
          confirmButtonText: '去实名',
          showClose:false,
          callback: action => {
            this.showRealnameBox()
          }});
          return 
      }
      let sourceData = this.tableData.filter(el=>this.parcel_id_list.includes(el.id));
      let sendaddress_Arr = [];
      let receiveraddress_Arr = [];
      let itemnode_Arr = [];
      sourceData.forEach((c,i)=>{
        sendaddress_Arr.push({index:i,origin_words:util.trimAll(c.sender_address)});
        receiveraddress_Arr.push({index:i,origin_words:util.trimAll(c.receiver_address)});
        itemnode_Arr.push({index:i,origin_words:util.trimAll(c.item_note)});
      })
      request.post(this,{
        action:'kdyserver.account.homeBus',
        data:{
          'parameters':request.getBusparameters([
            {action:'kdyserver.address.sensitivewords.check',data:sendaddress_Arr},
            {action:'kdyserver.address.sensitivewords.check',data:receiveraddress_Arr},
            {action:'kdyserver.address.sensitivewords.check',data:itemnode_Arr},
          ])
        }
      }).then(res=>{
        if(res.success){
          const datas = res.body.data;
          //筛选出对应 数组
          let filSender = datas[0].data.filter(el=>el.hit_sensitive == 1);
          let filReceiver = datas[1].data.filter(el=>el.hit_sensitive == 1); 
          let filNode = datas[2].data.filter(el=>el.hit_sensitive == 1); 
          // console.log(filSender,filReceiver,filNode,sourceData)
          sourceData.forEach((item,index)=>{
              item.sender_address = datas[0].data[index].sensitive_words
              item.receiver_address = datas[1].data[index].sensitive_words
              item.item_note = datas[2].data[index].sensitive_words
          })
          const concat_tableData = [...this.tableData,...sourceData];
          this.tableData = util.delRepeatJson(concat_tableData,'id');  
          const concat_fitArr = util.delRepeatJson([...filSender,...filReceiver,...filNode],'index') 
          let rowBgcolor = concat_fitArr.map(t=> t=t.index);
          this.rowBgcolor =[];
          rowBgcolor.forEach(el=>{
            this.rowBgcolor.push(this.parcel_id_list[el])
          })   
          this.$store.state.mgcColorRow = rowBgcolor;
          if(filSender.length == 0 && filReceiver.length == 0 && filNode.length == 0){
          //送检内容无敏感词
            if(type == 'saveTowait'){
              this.saveTowait_next();
            }else if(type == 'submitKdy'){
              this.faceLesswarn(()=>{this.submitKdy_next()});
            }else if(type == 'allPrint'){
              this.faceLesswarn(()=>{this.allPrint_next()});
            }else{}
          }else{
          //送检内容有敏感词
            this.$confirm("您输入的信息中含有敏感词请修改后重新操作点击忽略订单中将以“□”代替", '提示', {
              confirmButtonText: '忽略',
              cancelButtonText: '去修改',
              type: 'warning'
            }).then(() => {
              //修改成送检完成值
              if(type == 'saveTowait'){
                this.saveTowait_next();
              }else if(type == 'submitKdy'){
                this.faceLesswarn(()=>{this.submitKdy_next()});
              }else if(type == 'allPrint'){
                this.faceLesswarn(()=>{this.allPrint_next()});
              }else{}
            }).catch(() => {         
            });
          }
        
        }
      })
    },
    /** 批量打印 */
    allPrint() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要打印的订单",
        });
        return;
      }
      const {lodopStatus,WebSocketstatus,name} = this.$store.state.connetStatus
      if(!lodopStatus || !WebSocketstatus || !name){
        this.$printError(true);
        return
      }

      this.$confirm(
        "已选<span style='color:#ff0000'>" +
          this.parcel_id_list.length +
          "</span>个订单，确认打印已选订单？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
           this.jgSensitivewords('allPrint')
        })
        .catch(() => {});
    },
    //拆分批量打印白马分包处理
    allPrint_next(){
      this.allPrintLoading = true;
      // const pagenum = util.getJsonValues(this.$store.state.commondict,'hdbm2204') - 0 || 10
      let queryQarcelId = util.arrayGroup(this.parcel_id_list, 50);  //前端50一组分包提交
      console.log(queryQarcelId,'临时id号')
      this.waitprint_orderid = [];
      // let that = this;
      let busParams = queryQarcelId.map((el=>{
        return{
          action:'kdyserver.print.prePrintPcImportTempOrder',
          data:{
            account_id: util.getCookie("account_id"),
            ids: el.join(","),
            template_platform:"lodop",
            pri:this.ysBill ? 'PRI' : 'PT',
            value_add_type:this.value_add_type ? 'topay' : 'pt',
            source:8
          }
        }
      }))
      request.post(this,{
        action:'kdyserver.account.homeBus',
        data:{
          'noasync':1,
          'parameters':request.getBusparameters(busParams)
        }
        }).then(res=>{
          if(res.success){
            let len = busParams.length
            if(res.body.data[0].code == 201){   // 实名问题
              this.$message.error(res.body.data[0].message || res.body.data[0].remark);
              this.showRealnameBox()
              return
            }
            //错误提示处理
            let filerror = res.body.data.filter( el=>{ return el.code!=200 })   //过滤非200请求
            if(filerror.length){   //去重
              const norepeat_filerror = util.delRepeatJson(filerror,'code')
              for(let j = 0;j < norepeat_filerror.length;j++){
                this.$message.error(norepeat_filerror[j].message || norepeat_filerror[j].remark);
              }
            }
            for(let i = 0 ; i < len; i ++){
              this.waitprint_orderid = [...this.waitprint_orderid,...res.body.data[i].data]
              if(len == i+1){
                this.allPrint_last()
              }
            }
          } 
        })  
    },
    //批量打印的异步处理(总线)
    allPrint_last(){
      if(this.waitprint_orderid.length){
        util.gj_message("订单已打印，请在“已打印”中查看!",2000);
        PrintWaiting(this).then(res=>{
          if (res.initPrint) {
            const pagenum = util.getJsonValues(this.$store.state.commondict,'packsize') - 0 || 10
            var groupedArray = util.arrayGroup(this.waitprint_orderid, pagenum) 
            let busParams = groupedArray.map((el=>{
              return{
                action:'kdyserver.print.printOrder',
                data:{
                  account_id: util.getCookie("account_id"),
                  order_ids: el,
                  template_platform:"lodop"
                }
              }
            }))
            request.post(this,{
              action:'kdyserver.account.homeBus',
              data:{
                'parameters':request.getBusparameters(busParams)
              }
              }).then(res=>{
                if(res.success){
                  let len = busParams.length
                  for(let i = 0 ; i < len; i ++){
                    startPrinting(res.body.data[i].data)
                    if(len == i+1){
                      this.allPrintLoading = false;
                      this.all = false;
                      this.parcel_id_list = [];
                      this.loadData();
                    }
                  }
                } 
              })  
          }
        })         
      }else{
        this.all = false;
        this.allPrintLoading = false;
        this.parcel_id_list = [];
        this.loadData();
      }
    },
    /** 批量提交快递员 */
    submitKdy() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要提交给快递员的订单",
        });
        return;
      }
      this.$confirm(
        "已选<span style='color:#ff0000'>" +
          this.parcel_id_list.length +
          "</span>个包裹，确认提交已选订单？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        if(this.$store.state.bindKdy == 10){
          this.$message.warning('您当前未与快递员建立协议关系，无法提交快递员打印') 
          return  
        }
        this.jgSensitivewords('submitKdy');
      });
    },
    //拆分批量提交快递员
    submitKdy_next(){
      let queryQarcelId = util.arrayGroup(this.parcel_id_list, 50);  //前端50一组分包提交
      let prePromiseList = [];
      this.submit_orderid = [];
      let that = this;
      for(let index = 0; index < queryQarcelId.length; index++){
        let lsFlag = true;
        prePromiseList.push(new Promise((resolve, reject) => {
          print.lssumbKdy(this,queryQarcelId[index]).then(res=>{
            if(res.success){
              if(res.data.code == 201){
                this.showRealnameBox()
                lsFlag = false;
              }else if(res.data.code == 200){
                resolve({i:index,data:res.data})
              }else{
                resolve({i:index,data:res.data})
              }
            }else{
              lsFlag = false;
            }
          }) 
        }));  
        if(!lsFlag){
          break;
        }
      }
      if(!prePromiseList.length){   //实名出错
        return
      }
      Promise.all(prePromiseList).then((resproList)=> {
        resproList.map((data)=> {
          that.submit_orderid = [...that.submit_orderid,...data.data]
          if(queryQarcelId.length == data.i+1){
            if(this.parcel_id_list.length == that.submit_orderid.length){
              util.gj_message("订单已提交快递员，请在“待打印”中查看!",2000);
            }else{
              const num  = this.parcel_id_list.length - that.submit_orderid.length
              util.gj_message("订单中"+num+"单提交异常，请在“待打印”中查看!",2000);
            }
            that.parcel_id_list = [];
            that.all = false;
            that.loadData();
          }
        });
      }); 
    },
    //保存到待打印
    saveTowait() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要保存的包裹",
        });
        return;
      }
      this.$confirm(
        "已选<span style='color:#ff0000'>" +
          this.parcel_id_list.length +
          "</span>个包裹，确认保存已选订单？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        this.jgSensitivewords('saveTowait');
      });
    },
    //拆分待打印
    saveTowait_next(){
      home.saveTempOrder(this, this.parcel_id_list.join(",")).then((res) => {
        if (res.success) {
          if(res.data.code == 201){
            this.showRealnameBox()
            return
          }
          if (this.parcel_id_list.length == this.tableData.length) {
            this.$store.commit("SET_ROUTE_FROM", "/waitPrinted");
            this.$router.push("./waitPrinted");
            if (this.currPage == 1) {
              this.currPage = 1;
            } else {
              this.currPage--;
            }
          } else {
            this.$message.success("订单保存成功，请在“待打印”中查看");
          }
          this.parcel_id_list = [];
          this.loadData();
        }
      });
    },
    //批量删除
    batchDel() {
      if (!this.parcel_id_list.length) {
        this.$message({
          type: "warning",
          message: "没有选中的要删除的包裹",
        });
        return;
      }
      this.$confirm(
        "已选<span style='color:#ff0000'>" +
          this.parcel_id_list.length +
          "</span>个包裹，确认删除已选包裹？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      ).then(() => {
        home.delTempOrder(this, this.parcel_id_list.join(",")).then((res) => {
          if (res.success) {
            this.$message({
              message: "删除成功！",
              type: "success",
            });
            if (this.parcel_id_list.length == this.tableData.length) {
              if (this.currPage == 1) {
                this.currPage = 1;
              } else {
                this.currPage--;
              }
            }
            this.parcel_id_list = [];
            this.all = false;
            this.loadData(true);
          }
        });
      });
    },
    /** 改变条数 */
    changeSizes(e) {
      this.page_size = e;
      this.currPage = 1;
      let userset = JSON.parse(this.$store.state.userSet);
      userset.sizeNum = e;
      this.$store.commit("SET_USER_SET", JSON.stringify(userset));
      this.loadData();
    },
    /** 当前页 */
    currentPage(e) {
      this.currPage = e;
      this.loadData();
    },
    indexMethod(index) {
      return index + 1;
    },
    // 网点用户导入保存
    netSave() {
      this.isAuth = true;
      setTimeout(() => {
        this.$refs.auth.dialog = true;
      }, 200);
    },
    // 网点导入保存包裹信息
    saveParcels() {
      this.$confirm(
        "共<span style='color:#ff0000'>" +
          this.count.normal_count +
          "</span>个订单信息，确认保存这些订单吗",
        "提示",
        {
          confirmButtonText: "确认导入",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.$showLoading();
          this.isPrint = false;
          this.isLoading = true;
          Net.saveNetTempParcel(this).then((res) => {
            if (res.success) {
              this.$hideLoading();
              this.$message({
                message: "导入成功",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.$router.push("/net-pend/index");
                },
              });
            }
          });
        })
        .catch(() => {});
    },
    // 普通用户保存
    save() {
      this.$confirm(
        "共<span style='color:#ff0000'>" +
          this.count.normal_count +
          "</span>个订单信息，确认保存这些订单吗",
        "提示",
        {
          confirmButtonText: "确认导入",
          cancelButtonText: "取消",
          type: "warning",
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.$showLoading();
          this.isPrint = true;
          this.isLoading = true;
          api.saveTempParcel(this).then((res) => {
            if (res.success) {
              this.$hideLoading();
              this.$message({
                message: "导入成功",
                type: "success",
                duration: 1000,
                onClose: () => {
                  api.getQrcode(this).then((res) => {
                    if (res.success) {
                      this.qrcode(res.data);
                    }
                  });
                },
              });
            }
          });
        })
        .catch(() => {});
    },
    /** 编辑 */
    edit(data) {
      // this.itemData = Object.assign(this.itemData, data);
      // this.dialog = true;
      data.isfrom = 'excel'
      this.$store.commit("SET_EDIT_BILL", JSON.stringify(data));
      this.$store.commit("SET_ROUTE_FROM", "/editBill");
      this.$router.push({ path: "/editBill" });
    },
    /** 显示删除框 */
    showDel(id) {
      this.isDel = true;
      this.checked_id = id;
    },
    /** 删除 */
    del() {
      this.isDel = false;
      home.delTempOrder(this, this.checked_id).then((res) => {
        if (res.success) {
          this.$message({
            message: "删除成功！",
            type: "success",
          });
          this.loadData(true);
        }
      });
    },
    cancel() {
      this.$confirm(
        "确认取消本次导入操作吗？取消后将清除本次导入数据?",
        "提示",
        {
          confirmButtonText: "确认取消",
          cancelButtonText: "再考虑一下",
          type: "warning",
        }
      )
        .then(() => {
          setTimeout(() => {
            if (this.getFrom) {
              this.$router.push("/net-pend/index");
            } else {
              this.$router.push("/home");
            }
          }, 200);
        })
        .catch(() => {});
    },
    showTips() {
      if (!this.count.normal_count && !this.count.abnormal_count) {
        this.isNull = true;
        return;
      }
      this.tips = true;
    },
    //面单不足提醒
    async faceLesswarn(next){
      let result = await print.ywyauthorize()
      if(!result.success){
        const data = result.data;
        if(data.code == 9003){ //面单授权未开启
          if([1,2].includes(data.data.team_role)){  //团长或个人
            this.$toast(true,{
              title:'面单授权未开启',
              htmlstring:'<div>当前面单授权未开启，请联系合作快递员</div>'+
              '<div>“'+data.data.ywy_name+'”确定授权状态</div>'+
              '<div>快递员电话：'+data.data.ywy_phone+'</div>'
            },'ywyauthorize',()=>{
              // next()
            })
          }else{ //团员
            this.$toast(true,{
              title:'面单授权未开启',
              htmlstring:'<div>当前面单授权未开启，请尽快联系团长</div>'+
              '<div>向合作快递员确定授权状态</div>'
            },'ywyauthorize',()=>{
              // next()
            })
          }
        }else if(data.code == 9004){ //面单余额不足
          if([1,2].includes(data.data.team_role)){  //团长或个人
            this.$toast(true,{
              title:'面单余量过低提醒',
              htmlstring:'<div>当前剩余单量'+data.data.left_value+'单，请联系合作快递员</div>'+
              '<div>“'+data.data.ywy_name+'”充值面单</div>'+
              '<div>快递员电话：'+data.data.ywy_phone+'</div>'
            },'ywyauthorize',()=>{
              next()
            })
          }else{ //团员
            this.$toast(true,{
              title:'面单余量过低提醒',
              htmlstring:'<div>当前剩余单量'+data.data.left_value+'单，请尽快联系团长</div>'+
              '<div>充值面单</div>'
            },'ywyauthorize',()=>{
              next()
            })
          }
        }else{
          this.$message.error('查询面单余量失败code-'+ data.code)
        }
      }else{
        next()
      }
    },
  },
};
</script>
<style>
.el-table .ysb_wornig_row {
  background: rgba(230,162,60,.3);
}
</style>
<style lang="stylus" scoped>
.import_index {
  padding-bottom: 40px;

  nav {
    padding: 20px 0;
  }

  section {
    background: #ffffff;
    padding: 10px 20px 0;
    border-radius: 3px;

    .title {
      margin-bottom: 10px;
      color: #595959;
      font-size:14px;
      text-align:left
    }

    .pages {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      margin-bottom: 10px;

      .pages_right {
        display: flex;
      }
    }

    .table {
      .operation {
        a {
          padding: 0 5px;
          color: #1C8BF6;
        }
      }

      .noBody {
        min-height: 40vh;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 16px;

        img {
          width: 255px;
          height: 255px;
        }

        p {
          margin-top: 30px;
        }
      }
    }
  }

    footer {
    height: 40px;
    position: fixed;
    z-index: 99;
    left: 0;
    bottom: 0;
    right: 0;

    .footer {
      height: 40px;
      line-height: 40px;
      background: #ffffff;
      box-shadow: 1px 0 7px rgba(0, 0, 0, 0.1);
      padding-left: 60px;

      .cancel {
        margin-right: 20px;
        background: #fff;
        color: #1C8BF6;
        border: 1px solid #1C8BF6;
      }

      .disabel {
        background: #c5c5c5;
        color: #e3e3e3;
      }

      >div {
        width: 1200px;
        margin: 0 auto;
        text-align: center;

        .allCheck {
          float: left;
          span{
           padding-left:10px
           b{
            padding:0 5px;
            color:#1c8bf6
           }
          }
        }
        .btn {
          justify-content: center;
          align-items: center;
         .footBtn{
            width 160px
            margin-right 10px
            padding 8px 10px
          }
        }
      }
    }
  }
  .content {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: #212121;

    span {
      color: #FF0000;
    }
  }

  .piint_title, .print_content {
    text-align: center;
  }

  .print_content {
    margin-top: 20px;

    .qrcode {
      width: 180px;
      height: 180px;
      margin: 0 auto;
      padding-bottom: 15px;
    }
  }

  // 隐藏右上角叉号
  /deep/ .el-dialog__headerbtn .el-dialog__close {
    // display: none;
  }

  /deep/.el-dialog--center .el-dialog__body {
    padding-bottom: 10px;
  }

  .upFile {
    position: relative;
    cursor: pointer;
    display: inline-block;

    .file {
      cursor: pointer;
      position: absolute;
      width: 100%;
      height: 100%;
      right: 0;
      opacity: 0;
      z-index: 9;
    }
  }

  .model {
    padding: 0 40px;
    font-weight: normal;

    .title {
      color: #212121;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }

    .content {
      text-align: left;
    }

    .dowbload {
      padding: 15px 0;

      a {
        border: 1px solid #1C8BF6;
        padding: 6px 15px;
        border-radius: 4px;
      }
    }

    span {
      color: #FF0000;
    }
  }

  /deep/ .el-dialog__body {
    padding: 10px 40px;
  }
}
</style>
